import React, { useReducer, useEffect } from 'react'
import InsuranceApi from '../api/insurance.api'
import { EventEmitterService, EventKey } from '../services/EventEmitterService'
import { SessionService } from '../services/SessionService'
import { isToday, awaitWithLoading } from '../services/utils'
import StorageService from '../services/StorageService'
import brokerApi from '../api/broker.api'
import { Action } from '../models/Action'

const defaultState = {
  quotes: [],
  activeUsers: [],
  loadingUsers: true,
}

const reducer = (state, action) => {
  console.log('BuyingInsuranceContext state', state, action)
  switch (action.type) {
    case 'ACTIVE_USERS_LOADED':
      return { ...state, activeUsers: action.data, loadingUsers: false }
    case 'QUOTES_LOADED':
      return { ...state, quotes: action.data }
    default:
      return state
  }
}

export const BrokerPortalContextStore = React.createContext(defaultState)
BrokerPortalContextStore.displayName = 'Broker Portal ContextStore'
const BrokerPortalContext = props => {
  const [state, dispatch] = useReducer(reducer, defaultState)

  const loadQuotes = async () => {
    let res = await awaitWithLoading(Promise.all([brokerApi.getUsers(), brokerApi.getQuotes()]))
    if (res[0].ok) {
      dispatch(new Action('ACTIVE_USERS_LOADED', res[0].parsedData))
    } else {
      EventEmitterService.dispatch(EventKey.ShowError, res[0])
    }

    if (res[1].ok) {
      dispatch(new Action('QUOTES_LOADED', res[1].parsedData))
    }
  }

  useEffect(() => {
    loadQuotes()

    return function cleanup() {}
  }, [])

  return <BrokerPortalContextStore.Provider value={{ ...state, dispatch }}>{props.children}</BrokerPortalContextStore.Provider>
}

export default BrokerPortalContext
